























































































import {
    BBadge,
    BButton,
    BCard,
    BCardText,
    BCardTitle,
    BFormInput,
    BListGroup,
    BListGroupItem,
    BPopover,
    BSpinner,
} from "bootstrap-vue";
import { computed, defineComponent, nextTick, onMounted, ref, watch } from "@vue/composition-api";
import useContactLabels from "@/composables/v2.1/useContactLabels";
import Vue from "vue";
import axios from "@/libs/axios";
import { useToast } from "vue-toastification/composition";
import { textColorByBackgroundColor, styleByColor } from "@/utils/color";

// @ts-ignore
import i18n from "@/libs/i18n";
import ContactLabelInterface from "@/interfaces/contactLabel.interface";

export default defineComponent({
    components: {
        BBadge,
        BButton,
        BCard,
        BCardText,
        BCardTitle,
        BPopover,
        BFormInput,
        BListGroup,
        BListGroupItem,
        BSpinner,
    },
    props: {
        value: [],
        contactId: null,
    },
    name: "contactLabels",
    setup(props: { value: ContactLabelInterface[]; contactId: number }, context) {
        const bvModal = context.root.$bvModal;
        const { fetchContactLabels, contactLabels } = useContactLabels(bvModal);
        const toast = useToast();

        const isCollapsed = ref(true);
        const searchText = ref("");
        const showCollapse = ref(true);

        const deletingLabels = ref<Record<number, boolean>>({});
        const addingLabels = ref<Record<number, boolean>>({});

        fetchContactLabels({ params: { fields: "name,color", sort: "name,ASC" } });

        const labels = computed<ContactLabelInterface[]>({
            get() {
                return props.value || [];
            },
            set(value) {
                context.emit("input", value);
            },
        });

        const checkShowCollapse = () =>
            nextTick(() => {
                const labelsElement = context.refs.labelsElement as HTMLElement;

                showCollapse.value = labelsElement.clientHeight > 50;
            });

        onMounted(() => checkShowCollapse());

        watch(labels, () => checkShowCollapse(), {
            deep: true,
            immediate: false,
        });

        const selectableLabels = computed(() =>
            contactLabels.value.filter(
                (labelData: ContactLabelInterface) =>
                    labelData.name?.toLowerCase().includes(searchText.value.toLowerCase()) &&
                    labels.value.every((label) => label.id !== labelData.id)
            )
        );

        const removeLabel = (id: number) => {
            const updatedLabels = [...labels.value];
            const removeIndex = updatedLabels.findIndex((label) => label.id === id);

            updatedLabels.splice(removeIndex, 1);

            Vue.set(deletingLabels.value, id, true);

            axios
                .patch(`/contacts/${props.contactId}`, {
                    id: props.contactId,
                    labels: updatedLabels,
                })
                .then(() => {
                    Vue.set(deletingLabels.value, id, false);
                    labels.value = updatedLabels;

                    toast.success(i18n.t("entities.contact.labels.remove.success"));
                })
                .catch(() => toast.error(i18n.t("entities.contact.labels.remove.error")));
        };

        const addLabel = (label: any) => {
            Vue.set(addingLabels.value, label.id, true);

            const updatedLabels = [...labels.value, label];

            axios
                .patch(`/contacts/${props.contactId}`, {
                    id: props.contactId,
                    labels: updatedLabels,
                })
                .then(() => {
                    Vue.set(addingLabels.value, label.id, false);
                    labels.value.push(label);

                    toast.success(i18n.t("entities.contact.labels.add.success"));
                })
                .catch(() => toast.error(i18n.t("entities.contact.labels.add.error")));
        };

        return {
            showCollapse,
            selectableLabels,
            deletingLabels,
            addingLabels,
            searchText,
            removeLabel,
            addLabel,
            isCollapsed,
            labels,
            textColorByBackgroundColor,
            styleByColor,
        };
    },
});
